import PledgeBackground from '.'

export default PledgeBackground
